import {DimensionsModel} from "../models/App";

export const DIMENSIONS_DEFAULT: DimensionsModel = {width: 0, height: 0};
